export default "__VITE_ASSET__DXXF5huk__"